import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useUserInvitations = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: [{ entity: "userInvitations" }],
    queryFn: async () => await apiClient.getUserInvitations(),
    ...options,
  });
};
